module.exports = __webpack_public_path__ + "static/media/logo1.e6b74094.png";